import { useAtom } from 'jotai/react';
import {
  sidebarCollapsedAtom,
} from '../store/main-layout.store';

export const dashboardSidebarHook = (): {
  collapsed: boolean,
  setCollapsed: any,
} => {
  const [collapsed, setCollapsed] = useAtom(sidebarCollapsedAtom);

  return {
    collapsed,
    setCollapsed,
  };
};
